import {
  ADD_PROJECT
  DELETE_PROJECT
  LIST_PROJECTS
  SET_CURRENT_PROJECT
  SET_CONFIG_ENABLED
} from './actionTypes'

addProject = (payload)->
  type: ADD_PROJECT
  payload:
    data: payload

export deleteProject = (payload)->
  type: DELETE_PROJECT
  payload:
    data: payload

export updateProjects = (payload)->
  type: LIST_PROJECTS
  payload:
    data: payload

export createProject = (proj) ->
  (dispatch) ->
    p = new Weaver.Project()
    p.name = proj.name
    await p.create()
    p.addMetadata('META', 'description', proj.description)
    p.addMetadata('META', 'iconPath', proj.iconPath)
    p.addMetadata('META', 'visibleId', proj.visibleId)
    dispatch(addProject(proj))

export setCurrentProject = (proj) ->
  type: SET_CURRENT_PROJECT
  payload:
    data: proj

export setConfigEnabled = (payload) ->
  type: SET_CONFIG_ENABLED
  payload:
    data: payload
